import { makeAdSupportedGamePolicy } from './game-ads'

/** Plumbline — 진자 물리 하강 수집 게임. 무료 + AdMob 광고 + 광고 제거 인앱결제. */
export const PLUMBLINE_POLICY = makeAdSupportedGamePolicy({
  slug: 'plumbline',
  title: 'Plumbline Privacy Policy',
  name: 'Plumbline',
  storedOnDevice:
    'Which shafts you have finished, how many specimens you brought up from each, which specimens are on your shelf, how many dives you have made, whether you bought the ad removal, and your sound and music volume are the only things the app keeps.',
  removeAdsProductId: 'com.cottonray.plumbline.remove_ads',
  effectiveDate: 'August 25, 2026',
  history: [
    'August 25, 2026 — established (structured on Article 30 of the Personal Information Protection Act, including notice of transfers abroad), covering advertising through Google AdMob (a banner in a reserved strip along the bottom while you play and one interstitial when a game ends) and the one-off in-app purchase that removes them. The game requests network access for those two things only',
  ],
})
